export const formatTime = (timeString: string) => {
    if (!timeString) return '';
    return timeString.substring(0, 5); // Remove os segundos (:00)
  };